export default __webpack_public_path__ + "static/media/github.4b721bbc.svg";